import { render, staticRenderFns } from "./NewMenuList.vue?vue&type=template&id=797e0de7&scoped=true"
import script from "./NewMenuList.vue?vue&type=script&lang=js"
export * from "./NewMenuList.vue?vue&type=script&lang=js"
import style0 from "./NewMenuList.vue?vue&type=style&index=0&id=797e0de7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e0de7",
  null
  
)

export default component.exports